export default __webpack_public_path__ + "static/media/it-52.c2f17ec0.svg";